<script>
  import { getCartCount, getLoggedIn, getFlattenedNavRenderState } from '../../../../../js/stores';
  import { filterNavItems } from '../../../../../js/navItemFilters';
  import { dispatchOffsetLeftOnResize } from '../../../../../js/dispatchOffsetLeftOnResize';

  import ButtonLink from '../../../ButtonLink/ButtonLink.svelte';
  import Link from './Link/Link.svelte';
  import Category from './Category/Category.svelte';
  import CategoryFlattened from '../../DesktopNavFlattened/CategoryFlattened/CategoryFlattened.svelte';

  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();
  const flattenedNavRenderStore = getFlattenedNavRenderState();

  export let navItems = [];
  export let alignment = 'center';
  export let desktopMode;

  // Variables
  let element;
  let offsetLeft;

  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });
</script>

<ul
  class="NavList align-{alignment}"
  style="--nav-list-offset-left: {offsetLeft}px;"
  bind:this={element}
  use:dispatchOffsetLeftOnResize
  on:offsetLeftOnResize={({ detail }) => {
    offsetLeft = detail;
  }}
>
  {#each filteredItems as item (item)}
    {#if item.type === 'category'}
      <li class="category-item" class:hidden={item.hidden}>
        {#if $flattenedNavRenderStore}
          <CategoryFlattened
            {alignment}
            id={item.id}
            title={item.title}
            navItems={item.navItems}
            spotlightConfig={item.spotlight}
            {desktopMode}
          />
        {:else}
          <Category {alignment} id={item.id} title={item.title} navItems={item.navItems} {desktopMode} />
        {/if}
      </li>
    {:else if item.type === 'link'}
      {#if item.linkStyle === 'primary' || item.linkStyle === 'secondary'}
        <li class="button-item" class:hidden={item.hidden}>
          <ButtonLink id={item.id} title={item.title} url={item.url} linkStyle={item.linkStyle} />
        </li>
      {:else}
        <li class="link-item" class:hidden={item.hidden}>
          <Link id={item.id} title={item.title} url={item.url} />
        </li>
      {/if}
    {/if}
  {/each}
</ul>

<style>.NavList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
}
.NavList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.NavList > li::before {
  display: none;
}

.align-left {
  justify-content: flex-start;
}

.align-center {
  justify-content: center;
}

.align-right {
  justify-content: flex-end;
}

.button-item + .button-item {
  margin-left: 10px;
}</style>
